(() => {
  // Shopify can render this asset again when a section is reloaded in the editor.
  if (window.lomaVistaRaffleIntegrationLoaded) return;
  window.lomaVistaRaffleIntegrationLoaded = true;

  const rootSelector = '[data-lv-raffle-product]';
  const boundRoots = new WeakSet();

  function selectedVariantId(root) {
    const controls = [...root.querySelectorAll('[data-variant-input]')]
      .filter(input => input.type !== 'radio' || input.checked);

    if (!controls.length) return root.dataset.selectedVariantId || '';

    try {
      const variants = JSON.parse(root.querySelector('[data-variant-json]').value);
      const variant = variants.find(candidate => controls.every(input => {
        const optionIndex = Number(input.dataset.index.replace('option', '')) - 1;
        return candidate.options[optionIndex] === input.value;
      }));
      return variant ? String(variant.id) : '';
    } catch {
      // An unresolved selection must not submit a previous variant.
      return '';
    }
  }

  function syncVariant(root, variantId = selectedVariantId(root)) {
    const container = root.querySelector('panagora-raffle-container');
    // The initialized event also fires on failed requests. Preserve that state.
    if (!container?.startDate) return;
    const input = root.querySelector('panagora-raffle-form input[name="id"]');
    if (!input) return;

    input.value = variantId;
    // Panagora uses this event to refresh signup-button availability.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initialize(root) {
    // Rendered by the theme independently of the app's optional description.
    // Move the same block into position without tying it to signup state.
    const instructions = root.querySelector('[data-lv-raffle-instructions]');
    const container = root.querySelector('panagora-raffle-container');
    if (instructions && container) {
      const description = container.querySelector('.raffle-description');
      if (description) {
        description.after(instructions);
      } else {
        const dates = container.querySelector('.start-date');
        if (dates) dates.before(instructions);
      }
    }

    if (!boundRoots.has(root)) {
      boundRoots.add(root);
      // Impulse emits this on the product section, keeping quick-shop events isolated.
      root.addEventListener('variantChange', event => {
        syncVariant(root, event.detail.variant ? String(event.detail.variant.id) : '');
      });
    }

    root.querySelectorAll('button[is="panagora-raffle-button"]').forEach(button => {
      // Styling only: do not attach Impulse's normal add-to-cart behavior.
      button.classList.add('btn', 'btn--full');
    });
    root.querySelectorAll('.raffle-variants [data-variant-input]').forEach(input => {
      // The old Impulse form has been replaced. Let the moved controls belong
      // to their new containing form instead of the removed form's ID.
      input.removeAttribute('form');
    });
    syncVariant(root);
  }

  function initializeAll() {
    document.querySelectorAll(rootSelector).forEach(initialize);
  }

  // The app emits this after either success or failure; missing forms are safe.
  document.addEventListener('initialized', event => {
    if (!event.target.matches?.('panagora-raffle-container')) return;
    const root = event.target.closest(rootSelector);
    if (root) initialize(root);
  });
  document.addEventListener('shopify:section:load', initializeAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
